/*
 * Loading.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import { localization } from '../../config/localize/localizable'
import BaseModal from './BaseModal'

const Loading = () => {
    const isFetching = useIsFetching()
    const isMutating = useIsMutating()

    return (
        <>
            {isFetching || isMutating ? (
                <BaseModal>
                    <div className="select-none">{localization.loading}</div>
                </BaseModal>
            ) : null}
        </>
    )
}

export default Loading
